import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { getCurrentUser } from "@aws-amplify/auth";

import App from './App'
import Login from './Login'
import * as serviceWorker from './serviceWorker'

// import './assets/css/style.css'
import 'antd/dist/antd.variable.min.css'
/* import { ConfigProvider } from 'antd';

const theme = {
  components :{
    Select:{
      borderColor:"red",
      borderRadius:"5px",
      backgroundColor:"green"
    }
  }
} */
import { useEffect, useState } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import DefinePassword from './DefinePassword';


function Root() {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [newPasswordRequired, setNewPasswordRequired] = useState(true);

  useEffect(() => {
    getCurrentUser()
      .then(user => {
        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          setNewPasswordRequired(true);
          setAuthenticated(false);
        } else {
          setAuthenticated(true);
          setNewPasswordRequired(false);
        }
        setLoading(false);
      })
      .catch(() => {
        setAuthenticated(false);
        setNewPasswordRequired(false);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Carregando...</div>;
  }

  return (
    <Router>
      <Switch>
        {newPasswordRequired && (
          <Route path="/define-password" component={DefinePassword} />
        )}
        {!authenticated && !newPasswordRequired && (
          <Route path="/" component={Login} />
        )}
        {authenticated && !newPasswordRequired && (
          <Route path="/admin" component={App} />
        )}
        {/* Redirecionamentos automáticos */}
        {newPasswordRequired && <Redirect to="/define-password" />}
        {authenticated && !newPasswordRequired && <Redirect to="/admin" />}
      </Switch>
    </Router>
  );
}

ReactDOM.render(
  <React.StrictMode>
    {/* <ConfigProvider theme={theme}> */}
    <Root />
    {/* </ConfigProvider> */}
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
